import { defineMessages } from 'react-intl';

export const messages: {
	nameLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	namePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveToLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	adfError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyBodyError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentTooLargeFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentTooLargeFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagViewTemplateAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	nameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template name',
		description:
			'The text is shown as a field label above the template name text input in the Create or Edit Block Template modal, identifying the purpose of that input field.',
	},
	namePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description:
			'The text is shown as placeholder text inside the template name text input in the Create or Edit Block Template modal when the field is empty, guiding the user on what to type.',
	},
	nameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	descriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description:
			'The text is shown as a field label above the description text input in the Create or Edit Block Template modal, identifying the purpose of that input field.',
	},
	descriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description:
			'The text is shown as placeholder text inside the description text input in the Create or Edit Block Template modal when the field is empty, guiding the user on what to type.',
	},
	saveToLabel: {
		id: 'snippets.snippetEditorModal.saveToLabel',
		defaultMessage: 'Save to',
		description: 'Label for the Save to field (Personal/Site wide)',
	},
	adfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	emptyBodyError: {
		id: 'snippets.snippetEditorModal.emptyBodyError',
		defaultMessage: 'Template content cannot be empty',
		description: 'Error shown when the template body has no content',
	},
	cancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description:
			'Label on the cancel button in the block template editor modal that closes the modal without saving changes',
	},
	contentTooLargeFlagTitle: {
		id: 'snippets.snippetEditorModal.contentTooLargeFlagTitle',
		defaultMessage: 'Template content is too large',
		description:
			'Title for the error flag shown when template save fails due to content size limit',
	},
	contentTooLargeFlagDescription: {
		id: 'snippets.snippetEditorModal.contentTooLargeFlagDescription',
		defaultMessage: 'Reduce the content size and try again',
		description:
			'Description for the error flag shown when template save fails due to content size limit',
	},
	successFlagViewTemplateAction: {
		id: 'snippets.snippetEditorModal.successFlagViewTemplateAction',
		defaultMessage: 'View template',
		description:
			'Label for the action button in the success flag that opens the block templates panel',
	},
	successFlagDescription: {
		id: 'snippets.snippetEditorModal.successFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description text in the success flag shown after saving a template',
	},
});
